/** Read a cookie value by name (used for the Django CSRF token). */
export const getCookie = (name: string): string | undefined => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=').map((c) => c.trim());
    if (cookieName === name) return decodeURIComponent(cookieValue);
  }
  return undefined;
};

/** Server-injected config from the Django react.html shell. */
export const getKsdmConfig = (): KsdmConfig | undefined => window.__KSDM_CONFIG__;

/**
 * Websocket URL, matching the Backbone app (universal_map.js):
 * `${hostname}/${serverName}` — socket.io infers protocol + treats the path as
 * the namespace. serverName comes from the server-injected config.
 */
export const getWebsocketUrl = (): string => {
  const serverName = getKsdmConfig()?.serverName || 'dev';
  return `${location.hostname}/${serverName}`;
};
